module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921090834_T.8329672a.jpg";